// src/hooks/useTotalReservas.ts
import { useQuery } from "@tanstack/react-query";
import { fetchTotalReservas } from "../api/reports";

export function useTotalReservas(filters: Record<string, unknown>) {
  /* v5 → primera plantilla genérica es el tipo de data (number) */
  return useQuery<number>({
    queryKey: ["totalReservas", filters],
    queryFn: () => fetchTotalReservas(filters),
    /* en v5 ya no existe keepPreviousData;  placeholderData da el
       mismo efecto de “mostrar lo anterior” hasta que llegue el nuevo */
    placeholderData: (prev) => prev,
  });
}
